import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from "@material-tailwind/react";
import React, { useState } from "react";
import AddEditOrganisationEmployee from "../../modal/membership/AddEditOrganisationEmployee";

function EmployeeList(props) {
  // const [open, setOpen] = useState(0);
  // const [openEmapSection, setOpenEmapSection] = useState(0);
  // const [isOpen, setIsOpen] = useState(false);

  // const handleOpen = (value) => setOpen(open === value ? null : value);
  console.log("props.organisationEmployeeList_", props.organisationEmployeeList_);
  return (
    <>
      <div className="p-[25px]">
        <div className="grid grid-cols-12 gap-6 w-full items-center">
          <div className="xl:col-span-12 lg:col-span-12 col-span-12">
            <div className="overflow-x-auto">
              <div className="maping-table">
                <table className="w-full bg-white rounded-sm contribution-tble">
                  {/* Table body */}
                  <tbody className="text-sm custom-tbody">
                    {props.organisationEmployeeList_.map((emp, key) => (
                      <tr className="custom-tbl-td-contribution" key={key}>
                        <td className="w-[25%] whitespace-nowrap text-[#b92262] text-xl font-bold text-left pb-2">
                          {`${emp.firstName} ${emp.lastName}`}
                        </td>
                        <td className="w-[25%] p-0 whitespace-nowrap text-[#181818] font-medium text-xl text-left pb-2">
                          {emp.designation}
                        </td>
                        <td className="w-[50%] p-0 whitespace-nowrap text-[#181818] text-xl text-right pb-2">
                          {emp.isFinanceDepartmentRecord ? null :
                            <button
                              onClick={(e) => {
                                props.empModalOnOff(true, emp.individualMemberId, false);
                                props.setAddEditModel(true);
                                e.stopPropagation();
                              }}
                              className="underline text-xl text-[#b92262] plush-btn"
                            >
                              Edit Profile
                            </button>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="add-edite-profile-popup">
          <AddEditOrganisationEmployee
            salutation={props.salutation}
            jobFunctionList={props.jobFunctionList}
            organisationRolesList={props.organisationRolesList}
            employeeDetails={props.employeeDetails}
            setOrganisationEmployeeModal={props.setOrganisationEmployeeModal}
            handleChange={props.handleChange}
            setFilterParameters={props.setFilterParameters}
            handleChangeMultiDropdown={props.handleChangeMultiDropdown}
            ediCorporateEmployeeDetails={props.ediCorporateEmployeeDetails}
            validStateOrgEmployee={props.validStateOrgEmployee}
            validStateSearchByEmail={props.validStateSearchByEmail}
            isCreateNewOrgRoleForEmployee={props.isCreateNewOrgRoleForEmployee}
            validate={props.validate}
            searchIndividualMemberByEmailForOrgRole={props.searchIndividualMemberByEmailForOrgRole}
            deleteEmployee={props.deleteEmployee}
            isEmployeeModalEditable={props.isEmployeeModalEditable}
            validateField={props.validateField}
            onClose={(e) => {
              e.stopPropagation();
              props.empModalOnOff(false);
            }}
            setModalOpen={() => props.empModalOnOff(false)}
          />
        </div>
      </div>
    </>
  );
}
export default EmployeeList;